import type { Option } from '@comparit/core';
import { KuendigungDurchEnum } from '../../../interfaces';

export const kuendigungDurchOptions: Option<KuendigungDurchEnum>[] = [
  { label: 'Versicherungsnehmer', value: KuendigungDurchEnum.Versicherungsnehmer },
  { label: 'Versicherer', value: KuendigungDurchEnum.Versicherer },
  { label: 'Ungekündigt', value: KuendigungDurchEnum.Ungekuendigt },
];
